import {
  Parallax as SpringParallax,
  ParallaxLayer,
} from "@react-spring/parallax";
import BrandMainBanner from "./BrandMainBanner/BrandMainBanner";
import MainBannerOne from "./MainBanner/MainBannerOne";
import "./MainBanner/MainBannerOne.scss";
import { useIdleTimer } from "react-idle-timer";
import { useState } from "react";
import TopButtons from "../button/TopButtons";
import BottomButtons from "../button/BottomButtons";
import Mainlogos from "./MainBanner/MainLogos";

function MainBanner(props) {
  const [move, setMove] = useState(true);

  const handleOnIdle = (event) => {
    setMove(false);
    // ------- when user is idle
    // console.log("home user is idle", event);
    // console.log("home last active", getLastActiveTime());
  };

  const handleOnActive = (event) => {
    // ------- when user is active
    // console.log("home user is active", event);
    // console.log("home time remaining", getRemainingTime());
  };

  const handleOnAction = (event) => {
    setMove(true);
    // ------- when user did something
    // console.log("home user did something", event);
  };

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 4000,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    // debounce: 500,
  });
  return (
    <>
      {move && <Mainlogos />}
      <MainBannerOne move={move} />
      <div className="brandDiv">
        <BrandMainBanner move={move} />
      </div>
    </>
  );
}
export default MainBanner;
